module.exports = __webpack_public_path__ + "static/gold-ball-7c127d7e9ea4861837b9e1affa76f804.png";